<template>
    <form @change="sendDataForSaving">
        <div class="row align-items-center">
            <div class="col-sm-3">
                <div class="form-group form-group-1">
                    <p>Notifications</p>
                </div>
            </div>
            <div class="col-sm-2 pl-0">
                <div class="form-group form-group-1">
                    <input type="number" min="1" class="form-control" v-model="notification.reminder_time">
                </div>
            </div>
            <div class="col-sm-2 pl-0">
                <div class="form-group form-group-1">
                    <select class="custom-select" v-model="notification.reminder_unit">
                        <option value="hours">Hours</option>
                        <option value="minutes">Minutes</option>
                    </select>
                </div>
            </div>
            <div class="col-sm-1 pl-0">
                <button
                    v-if="isDeletable"
                    class="img-btn mb-5"
                    @click.prevent="deleteNotification"
                ><img src="/img/svg/del.svg" alt="delete"></button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'NotificationItem',
    props: {
        notificationInfo: {
            type: Object,
            required: true,
        },
        index: {
            type: Number
        },
        isDeletable: Boolean
    },
    emits:['data-changed', 'delete'],
    data() {
        return {
            notification: {
                id: null,
                index: this.index,
                reminder_time: null,
                reminder_unit: null,
            }
        }
    },
    methods: {
        sendDataForSaving() {
            this.$emit('data-changed', this.notification);
        },
        deleteNotification() {
            this.$emit('delete', this.notification)
        },
        setData() {
            for (const userKey in this.notificationInfo) {
                for (const formKey in this.notification) {
                    if (userKey === formKey) {
                        this.notification[userKey] = this.notificationInfo[formKey];
                    }
                }
            }
        },
    },
    mounted() {
        this.setData();
    },
    watch: {
        'notificationInfo': {
            handler: function (newInfo) {
                if (newInfo !== this.notification) {
                    this.setData();
                }
            },
            immediate: true,
        },
    }
}

</script>



<style scoped>

</style>
